import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import StudentOverview from "../components/student-progress/StudentOverview";

const StudentOverView = () => {
  return (
    <AdminLayout>
      <StudentOverview />
    </AdminLayout>
  );
};

export default StudentOverView;
